import { gql } from '@apollo/client';

export const CANDIDATE_FULL_FIELDS_FRAGMENT = gql`
  fragment CandidateFullFields on Candidate {
    id
    birthDate
    permanentOrTemporary
    gender
    yearsOfExperience
    germanSpeakingLevel
    driversLicense
    canStartOn
    nursingArea
    employmentTypesWeeklyHour
    employmentTypes
    priority
    nursingApprenticeshipExperience
    typesOfWork
    caregiverQualifications
    hasPassword
    isWithinSuggestionsModalDisplayLimit
    email
    firstName
    lastName
    phoneNumber
    status
    followUpDate
    files {
      id
      name
      nameInBucket
      type
    }
    profilePictureKey
    jobTitleAnswers {
      id
      jobTitle {
        deputy
        id
        title
        trackingPriority
      }
      selected
      hasQualification
      createdAt
      isPending
    }
    documentationSystems {
      id
      title
    }
    departments {
      name
      id
    }
    locations {
      city
      country
      formattedAddress
      id
      location
      placeId
      postalCode
    }
    employmentTypes
    educationHistories {
      title
      endDate {
        month
        year
      }
      id
      institution
      practiceInstitution
      country
      ongoing
      startDate {
        month
        year
      }
    }
    workHistories {
      city
      country
      description
      employer
      cvLabel
      endDate {
        month
        year
      }
      id
      jobTitle
      ongoing
      startDate {
        month
        year
      }
      state
      type
      facilityDesignation
    }
    trainingHistories {
      id
      ongoing
      title
      year
      month
    }
    emailConfirmedAt
    createdAt
    transportationType
    howHappyAreYou
    wishlist
    motivations {
      id
      text
      default
    }
    qualifications {
      area
      id
      title
      typeOfEmployer
    }
    softSkills {
      id
      text
      default
    }
    wantFromEmployers {
      id
      text
      default
    }
    emailNotifications
    smsNotifications
    candidateProfileState
    schoolCertificate
  }
`;
